<template>
  <base-sheet :visible="visible" @close="$emit('cancel')">
    <div class="vxl-sheet__head">
      <span class="vxl-sheet__icon" style="color: #f9a825">
        <i class="material-icons">signal_cellular_alt</i>
      </span>
      <div class="vxl-sheet__head-text">
        <h3 class="vxl-sheet__title">Baixar usando dados móveis?</h3>
        <p v-if="itemName" class="vxl-sheet__item">{{ itemName }}</p>
      </div>
    </div>

    <p class="vxl-sheet__subtitle desc">
      Você está conectado por rede móvel. Esse download pode consumir uma parte
      significativa do seu plano de dados.
    </p>

    <!-- Checkbox custom: o input nativo fica fora do fluxo visual porque o
         Materialize aplica opacity:0 + position:absolute via
         [type="checkbox"]:not(:checked), e essa specificity não é vencível de
         dentro do scoped CSS sem hack. O <i> ao lado reflete o estado; a label
         envolve os dois, então o toque alterna e o input segue focável. -->
    <label class="remember">
      <input type="checkbox" v-model="dontAskAgain" class="remember__native" />
      <i class="material-icons remember__box" :class="{ 'remember__box--on': dontAskAgain }">
        {{ dontAskAgain ? 'check_box' : 'check_box_outline_blank' }}
      </i>
      <span>Não perguntar novamente</span>
    </label>

    <button
      type="button"
      class="vxl-sheet__action vxl-sheet__action--primary"
      :style="{ background: $theme.primaryColor }"
      @click="$emit('confirm', { persist: dontAskAgain })"
    >
      <i class="material-icons">file_download</i>
      Baixar mesmo assim
    </button>
    <button type="button" class="vxl-sheet__action vxl-sheet__action--ghost" @click="$emit('cancel')">
      Agora não
    </button>
  </base-sheet>
</template>

<script>
import BaseSheet from '@/components/base/BaseSheet';

// Confirmação antes de baixar em rede móvel. `persist` no evento = o usuário
// marcou "não perguntar novamente" (vira preferência salva, não decisão só
// desta fila).
export default {
  name: 'ConfirmCellularDownload',
  components: { BaseSheet },
  props: {
    visible: { type: Boolean, default: false },
    itemName: { type: String, default: null }
  },
  data () {
    return { dontAskAgain: false };
  },
  watch: {
    // Reabrir não pode herdar o "não perguntar novamente" de uma abertura
    // anterior que o usuário cancelou.
    visible (now) {
      if (now) this.dontAskAgain = false;
    }
  }
};
</script>

<style scoped lang="scss">
.desc {
  margin-top: 12px;
}

.remember {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 4px 16px;
  font-size: 13px;
  color: var(--md-text-dim, rgba(255, 255, 255, 0.7));
  cursor: pointer;

  &__native {
    // Fora do fluxo visual, mas focável — ver comentário no template.
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  &__box {
    font-size: 20px;
    color: var(--md-border-strong, rgba(255, 255, 255, 0.4));

    &--on {
      color: #2fca6e;
    }
  }
}
</style>
